import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBIcon, MDBModalFooter } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";

// Returns true if filter values a and b conflict (duplicate, subset, or superset).
const areFiltersConflicting = (a, b) => {
  if (!a || !b) return false;
  const aVal = a.trim();
  const bVal = b.trim();
  if (aVal === bVal) return true;

  // Wildcard (*) conflict checks removed — only exact 10-digit numbers are now allowed.
  // const aIsPrefix = aVal.endsWith("*") && !aVal.startsWith("*");
  // const bIsPrefix = bVal.endsWith("*") && !bVal.startsWith("*");
  // const aIsSuffix = aVal.startsWith("*") && !aVal.endsWith("*");
  // const bIsSuffix = bVal.startsWith("*") && !bVal.endsWith("*");
  //
  // if (aIsPrefix && bIsPrefix) {
  //   const ap = aVal.slice(0, -1);
  //   const bp = bVal.slice(0, -1);
  //   return ap.startsWith(bp) || bp.startsWith(ap);
  // }
  // if (aIsSuffix && bIsSuffix) {
  //   const as_ = aVal.slice(1);
  //   const bs = bVal.slice(1);
  //   return as_.endsWith(bs) || bs.endsWith(as_);
  // }
  // if (aIsPrefix) return bVal.startsWith(aVal.slice(0, -1));
  // if (bIsPrefix) return aVal.startsWith(bVal.slice(0, -1));
  // if (aIsSuffix) return bVal.endsWith(aVal.slice(1));
  // if (bIsSuffix) return aVal.endsWith(bVal.slice(1));

  return false;
};

const getConflictingFilter = (newValue, filters, excludeValue = null) => {
  const newVal = newValue.trim();
  if (!newVal) return null;
  for (const filter of filters) {
    const existingVal = (filter.value || "").trim();
    if (!existingVal) continue;
    if (excludeValue !== null && existingVal === excludeValue.trim()) continue;
    if (areFiltersConflicting(newVal, existingVal)) return filter;
  }
  return null;
};

const AddCallerID = (props) => {
  const { t } = useTranslation();
  const nameRef = useRef();
  const [filterLabel, setFilterLabel] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [isValidName, setIsValidName] = useState(true);
  const [isValidPh, setIsValidPh] = useState(true);
  // const [isTooShort, setIsTooShort] = useState(false);
  const [isDuplicateName, setIsDuplicateName] = useState(false);
  const [conflictingFilter, setConflictingFilter] = useState(null);

  const callerIDRegex = /^[a-zA-Z0-9\s\-_]*$/;
  // Old regex allowed * wildcards — removed:
  // const phoneNumberRegex = /^(?!.*\*\*)(?:(\+1|1)?[2-9]\d{2}[2-9]\d{6}|\*\d{3,}|\d{3,}\*)$/;
  const phoneNumberRegex = /^\d{10}$/;

  const validateName = (value) => {
    const trimmed = value.trim();
    if (trimmed === "") return true;
    return trimmed.length >= 1 && callerIDRegex.test(trimmed);
  };

  const validatePh = (value) => {
    const trimmed = value.trim();
    if (trimmed === "") return true;
    return trimmed.length >= 3 && phoneNumberRegex.test(trimmed);
  };


  const isDuplicateFilter = (name) => {
    if (!name || name.trim() === "") return false;
    const existingFilters = props.existingFilters || [];
    return existingFilters.some(
      (filter) => filter.name && filter.name.toLowerCase() === name.trim().toLowerCase()
    );
  };

  const addCFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const nameValid = validateName(filterLabel);
    const phValid = filterValue.trim() !== "" && validatePh(filterValue);
    const duplicate = isDuplicateFilter(filterLabel);
    const conflict = phValid ? getConflictingFilter(filterValue, props.existingFilters || []) : null;
    // const trimmedPh = filterValue.trim();

    setIsValidName(nameValid);
    setIsValidPh(phValid);
    // setIsTooShort(trimmedPh.length > 0 && trimmedPh.length < 3);
    setIsDuplicateName(duplicate);
    setConflictingFilter(conflict);

    if (nameValid && phValid && !duplicate && !conflict) {
      props.addCFilter(e, filterLabel, filterValue);
    }
  };


  const handleNameChange = (event) => {
    const value = event.target.value.trim();
    setFilterLabel(value);
    setIsValidName(validateName(value));
    setIsDuplicateName(isDuplicateFilter(value));
  };

  const handlePhoneNumberChange = (event) => {
    const value = event.target.value.trim();
    setFilterValue(value);
    // const trimmed = value.trim();
    // setIsTooShort(trimmed.length > 0 && trimmed.length < 3);
    setIsValidPh(validatePh(value));
    setConflictingFilter(
      validatePh(value) ? getConflictingFilter(value, props.existingFilters || []) : null
    );
  };

  useEffect(() => {
    if (nameRef.current) {
      setTimeout(() => {
        nameRef.current.focus();
      }, 500);
    }
  }, []);

  return (
    <>
      <div>
        <div className="tel-numbers">
          <strong>{t("name")}</strong>
        </div>
        <div className="form pt-1">
          <input
            ref={nameRef}
            type="text"
            className="form-control w-100"
            tabIndex={-1}
            maxLength={15}
            onChange={handleNameChange}
          />
          {!isValidName && (
            <p style={{ color: "red" }}>{t("alphanumeritext")}</p>
          )}
          {isDuplicateName && isValidName && (
            <p style={{ color: "red" }}>Filter name already exists.</p>
          )}
          <div className="tel-numbers mt-2">
            <strong>{t("Filter")}</strong>
          </div>
          <div className="form position-relative">
            <input
              type="text"
              className="form-control w-100"
              tabIndex={-2}
              maxLength={10}
              onChange={handlePhoneNumberChange}
            />
            <div className="addFilterInfoIcon">
              <MDBIcon fas icon="info-circle" className="deleteToolTip" />
            </div>
          </div>
          <p className="text-secondary">
            {/* Enter a 10 digit phone number, use * as a wildcard. */}
            Enter a 10 digit phone number.
          </p>
          {/* {!isValidPh && isTooShort && (
            <p style={{ color: "red" }}>At least 3 digits are required to create a filter</p>
          )}
          {!isValidPh && !isTooShort && (
            <p style={{ color: "red" }}>{t("validnumber")}</p>
          )}
          {isValidPh && conflictingFilter && (
            <p style={{ color: "red" }}>
              Filter value conflicts with existing filter &quot;{conflictingFilter.name}&quot; ({conflictingFilter.value}).
            </p>
          )} */}
            {!isValidPh && (
            <p style={{ color: "red" }}>{t("validnumber")}</p>
          )}
          {isValidPh && conflictingFilter && (
            <p style={{ color: "red" }}>
              Filter value conflicts with existing filter &quot;{conflictingFilter.name}&quot; ({conflictingFilter.value}).
            </p>
          )}
        </div>
        <MDBModalFooter>
          <MDBBtn color="secondary" onClick={props.toggleCFilter}>
            {t("close")}
          </MDBBtn>
          <MDBBtn onClick={addCFilter}>{t("add")}</MDBBtn>
        </MDBModalFooter>
      </div>
      <Tooltip
        anchorSelect=".deleteToolTip"
        place="top"
        className="exampleTooltip"
      >
        {/* The filter length must be 10 digits. You can use '*' as a wildcard. */}
        The filter must be exactly 10 digits.
      </Tooltip>
    </>
  );
};

export default AddCallerID;
